import { styled } from '@mui/material/styles';
import { SimpleForm } from 'react-admin';

export const SimpleFormStyled = styled(SimpleForm)({
  paddingTop: '50px',
});

export const Row = styled('div')({
  display: 'flex',
  alignItems: 'baseline',
  flexWrap: 'wrap',
  gap: '20px',

  width: '100%',
});
